export default {
    user: {
        name: "管理员"
    }
};
